'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _youtubeWatchingStats = require('../youtube-watching-stats');

var _youtubeWatchingStats2 = _interopRequireDefault(_youtubeWatchingStats);

var _transformer = require('../../reports/hero-report/transformer');

var _transformer2 = _interopRequireDefault(_transformer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cursorPointer = {
  cursor: 'pointer'
};

var smallFont = {
  fontSize: '60%',
  color: 'grey'
};

var YoutubeModalComponent = function YoutubeModalComponent(_ref) {
  var post = _ref.post;

  var mainData = _transformer2.default.getHeroData({
    posts: [post]
  });
  var heroPost = _transformer2.default.getHeroPost({
    posts: [post]
  });
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      trigger: _react2.default.createElement(
        'div',
        { style: cursorPointer },
        _react2.default.createElement(_semanticUiReact.Icon, {
          title: 'view full data',
          name: 'expand'
        }),
        _react2.default.createElement(
          'div',
          { style: smallFont },
          'view...'
        )
      )
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      'YouTube Video Performance'
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(_youtubeWatchingStats2.default, { mainData: mainData, heroPost: heroPost })
    )
  );
};

YoutubeModalComponent.propTypes = {
  post: _propTypes2.default.object.isRequired
};

exports.default = YoutubeModalComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-modal-component/index.js
 ** module id = 2573
 ** module chunks = 0
 **/